import { type InsightsClient } from 'search-insights';

import { getAlgoliaAnalyticsStorage } from '@jsmdg/browser-storage';
import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import {
    type AddedObjectData,
    AlgoliaAnalyticsEventAction,
    AlgoliaAnalyticsEventPage,
    AlgoliaAnalyticsEventSource,
    formatAlgoliaAnalyticsEventName,
} from '@jsmdg/tracking';

type AlgoliaAnalyticsDataWithUserToken = {
    indexName: string;
    queryId: string;
    timestamp: number;
    userToken?: string;
};

export const sendAlgoliaProductAddedEvent = ({
    insightsClient,
    productId,
    objectData,
    value,
    currency,
    userToken,
}: {
    insightsClient: InsightsClient;
    productId: string;
    objectData: AddedObjectData[];
    value: number;
    currency: string;
    userToken?: string;
}): void => {
    try {
        const analyticsLocalStorage = getAlgoliaAnalyticsStorage();
        const algoliaAnalyticsObject = analyticsLocalStorage.getAnalyticsObject(productId);

        if (algoliaAnalyticsObject) {
            const algoliaAnalyticsData = Object.values(algoliaAnalyticsObject).reduce(
                (prev, curr) => (prev.timestamp > curr.timestamp ? prev : curr),
            ) as AlgoliaAnalyticsDataWithUserToken;

            const eventUserToken = algoliaAnalyticsData.userToken ?? userToken;
            if (!eventUserToken) {
                return;
            }

            insightsClient('setUserToken', eventUserToken);
            insightsClient('addedToCartObjectIDsAfterSearch', {
                eventName: formatAlgoliaAnalyticsEventName({
                    page: AlgoliaAnalyticsEventPage.ProductDetailPage,
                    source: AlgoliaAnalyticsEventSource.BuyBox,
                    action: AlgoliaAnalyticsEventAction.ProductAddedToCart,
                }),
                index: algoliaAnalyticsData.indexName,
                queryID: algoliaAnalyticsData.queryId,
                objectIDs: [productId],
                objectData,
                value,
                currency,
                userToken: eventUserToken,
            });
        }
    } catch (error) {
        logToSentry(error as Error);
    }
};
